import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DxButtonModule,
  DxLoadPanelModule,
  DxTabsModule,
  DxToolbarModule,
} from 'devextreme-angular';
import { ScreenService } from '../screen.service';
import { taskPanelItems } from '../resource';
import { DxTabsTypes } from 'devextreme-angular/ui/tabs';
import { DxTextBoxTypes } from 'devextreme-angular/ui/text-box';
import { TaskListGridComponent } from './task-list-grid/task-list-grid.component';
import { Observable } from 'rxjs/internal/Observable';
import { Task, newTask } from './task';
import { forkJoin, map } from 'rxjs';
import { TaskService } from '../planing.service';
import { TaskFormComponent } from './task-form/task-form.component';
import { TaskListKanbanComponent } from './task-list-kanban/task-list-kanban.component';
import { TaskListGanttComponent } from './task-list-gantt/task-list-gantt.component';
import { Router } from '@angular/router';
import {FormTaskPopupComponent} from "@dabnet-kamu/libs/ui/shared/planing/task/form-popup/form-popup.component";

@Component({
  selector: 'dk-task',
  standalone: true,
  imports: [
    CommonModule,
    DxToolbarModule,
    DxTabsModule,
    DxButtonModule,
    TaskListGridComponent,
    DxLoadPanelModule,
    TaskFormComponent,
    TaskListKanbanComponent,
    TaskListGanttComponent,
    FormTaskPopupComponent,
  ],
  templateUrl: './task.component.html',
  styleUrls: ['./task.component.scss'],
})
export class TaskComponent implements OnInit {
  @Output() private closePopup = new EventEmitter<string>();

  @ViewChild('planningDataGrid', { static: false })
  dataGrid: any;
  @ViewChild('planningGantt', { static: false }) gantt: any;
  @ViewChild('planningKanban', { static: false })
  kanban: any;
  taskPanelItems = taskPanelItems;
  displayTaskComponent = this.taskPanelItems[0].text;
  isAddTaskPopupOpened = false;
  displayGrid = this.displayTaskComponent === this.taskPanelItems[0].text;
  displayKanban = this.displayTaskComponent === this.taskPanelItems[1].text;
  taskCollections$: Observable<{ allTasks: Task[]; filteredTasks: Task[] }>;
  newTask = newTask;

  constructor(
    public screen: ScreenService,
    private service: TaskService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.taskCollections$ = forkJoin([
      this.service.getFilteredTasks(),
      this.service.getTasks(),
    ]).pipe(
      map(([filteredTasks, allTasks]) => {
        return { allTasks, filteredTasks };
      })
    );
  }

  tabValueChange(e: DxTabsTypes.ItemClickEvent) {
    const { itemData } = e;

    this.displayTaskComponent = itemData.text;
    this.displayGrid =
      this.displayTaskComponent === this.taskPanelItems[0].text;
    this.displayKanban =
      this.displayTaskComponent === this.taskPanelItems[1].text;
  }

  addTask = () => {
    this.isAddTaskPopupOpened = true;
  };

  refresh = () => {
    if (this.displayGrid) {
      this.dataGrid.refresh();
    } else if (this.displayKanban) {
      this.kanban.refresh();
    } else {
      this.gantt.refresh();
    }
  };

  chooseColumnDataGrid = () => this.dataGrid.showColumnChooser();

  searchDataGrid = (e: DxTextBoxTypes.InputEvent) =>
    this.dataGrid.search(e.component.option('text'));

  exportToPdf = () => {
    if (this.displayGrid) {
      this.dataGrid.onExportingToPdf();
    } else {
      this.gantt.onExporting();
    }
  };

  exportDataGridToXSLX = () => this.dataGrid.onExportingToXLSX();

  goBack() {
    this.router.navigate(['/main/dabnet']);
  }
}
